import React, {useEffect, useMemo, useState} from "react";
import {Box, CircularProgress, Typography} from "@mui/material";
import FormRenderer from "../Forms/FormRenderer";
import {makeCresAxiosFoundationAPI} from "../../util/AxiosFoundationAPI";
import {useSessionContext} from "../../util/SessionContext";
import {Grey7} from "../../theme/styles";

/**
 * A product's fields, read under its row in a project: the Product form, drawn read-only from the
 * record's own contract with the answers object_form_input holds -- the same draw the Form tab and
 * the record drawer make. A product is an Item of type PRT- (2026-10-29), so there is no development
 * read to call; the record IS the form.
 */
export default function ProductForm({revisionUSID}: {revisionUSID?: string | null}) {
    const sessionContext = useSessionContext();
    const api = useMemo(() => makeCresAxiosFoundationAPI(sessionContext), [sessionContext]);
    const [values, setValues] = useState<Record<string, any> | null>(null);
    const [problem, setProblem] = useState<string | null>(null);

    useEffect(() => {
        if (!revisionUSID) return;
        let live = true;
        setValues(null); setProblem(null);
        api.get("t1/v1/object_form_input", {params: {ObjectRevisionUSID: revisionUSID}})
            .then((response: any) => { if (live) setValues(response?.data?.PlatformMessage?.Values ?? response?.data?.Values ?? {}); })
            .catch((failure: any) => { if (live) setProblem(failure?.response?.data?.Cause ?? "The product's form could not be read."); });
        return () => { live = false; };
    }, [api, revisionUSID]);

    if (!revisionUSID) return null;
    if (problem) return <Typography sx={{fontSize: 13, color: "#B3261E", paddingTop: "8px"}}>{problem}</Typography>;
    if (values === null) {
        return <Box sx={{display: "flex", gap: "10px", alignItems: "center", padding: "12px 0"}}>
            <CircularProgress size={16}/>
            <Typography sx={{fontSize: 13, color: Grey7}}>Reading the product…</Typography>
        </Box>;
    }
    return <Box sx={{paddingTop: "8px"}}><FormRenderer objectRevisionUSID={revisionUSID} value={values} readOnly/></Box>;
}
